import { render, staticRenderFns } from "./WDualListSelector.vue?vue&type=template&id=1090bec5&scoped=true&"
import script from "./WDualListSelector.vue?vue&type=script&lang=js&"
export * from "./WDualListSelector.vue?vue&type=script&lang=js&"
import style0 from "./WDualListSelector.vue?vue&type=style&index=0&id=1090bec5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1090bec5",
  null
  
)

export default component.exports